import ProductWidgetContainer from "./ProductWidgetContainer";
import DraftNumberInput from "../../../inputs/DraftNumberInput";
import { getCeiling } from "../../../../adapters/baselineLoadAdapter";
import styled from "styled-components/macro";

const FlexSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;

const SectionNote = styled.p`
  color: var(--color-foreground-de-emp);
  font-size: 0.85rem;
  margin: 0 0 12px 0;
`;

const MaestroProductWidget = ({
  product,
  onRemove,
  onProductChange,
  editable,
  baselineProfile,
  deploymentType,
}: {
  product: ProductOptionInterface;
  onRemove: () => void;
  onProductChange: (updatedProduct: ProductOptionInterface) => void;
  editable: boolean;
  baselineProfile: string;
  deploymentType: string;
}) => {
  const handleProfileChange = (newProfile: string) => {
    const productCopy = { ...product, profile: newProfile };
    onProductChange(productCopy);
  };

  const wfInput = (label: string, field: string, helperText?: string) => (
    <DraftNumberInput
      label={label}
      helperText={helperText}
      product={product}
      field={field}
      baselineProfile={baselineProfile}
      editable={editable}
      onProductChange={onProductChange}
    />
  );

  // Guard: an uncapped field must not render "Capped at undefined days".
  const retentionCeiling = getCeiling("maestro", "retentionDays");
  const retentionHelp =
    "Match the retention configured on your Maestro processes in Orchestrator." +
    (retentionCeiling !== undefined
      ? ` Capped at ${retentionCeiling} days (Temporal's own retention ceiling).`
      : "");

  return (
    <ProductWidgetContainer
      onRemove={onRemove}
      title={product.name}
      productKey={product.key}
      canBeRemoved={product.canBeRemoved}
      productProfile={product.profile}
      deploymentType={deploymentType}
      onProfileChange={handleProfileChange}
    >
      <SectionNote>
        Enter expected workflows per day for each complexity tier. Simple ≈ 3 BPMN
        tasks. Moderate ≈ 25 tasks + 1 subprocess (5 tasks). Complex ≈ 100 tasks +
        3 subprocesses (5 tasks each).
      </SectionNote>
      <FlexSection>
        {wfInput("Simple workflows per day", "simpleWfPerDay")}
        {wfInput("Moderate workflows per day", "moderateWfPerDay")}
        {wfInput("Complex workflows per day", "complexWfPerDay")}
        {wfInput("Process retention (days)", "retentionDays", retentionHelp)}
      </FlexSection>
    </ProductWidgetContainer>
  );
};

export default MaestroProductWidget;
